<div class="empty-state-container" [class.empty-state-card]="card" [class.empty-state-error]="isError">
  @if (emptyStateIcon) {
    <i class="fa-solid fa-3x empty-state-icon {{emptyStateIcon}}"></i>
  }
  @if (headerText) {
    <p class="empty-state-header-text">{{headerText}}</p>
  }
  @if (helpText) {
    <p class="empty-state-text">{{helpText}}</p>
  }
  <ng-content></ng-content>
</div>
